import { withLeading, buildDateObject } from '@/tools/date'

const DROPDOWN_TRANSITION_DURATION = 500

export default class Search {
  constructor(element, host) {
    this.element = element
    this.host = host
    this.searchElement = element.getElementsByClassName(
      'header-search__field'
    )[0]
    this.suggestionsEl = element.getElementsByClassName('input-suggestions')[0]
    this.container = element.getElementsByClassName(
      'input-suggestions__container'
    )[0]
    this.noResults = element.getElementsByClassName(
      'input-suggestions__none'
    )[0]

    this.overlayEl = {}
    this.timeout = {}

    this.timezoneOffset = 0

    this.query = ''
    this.request = new XMLHttpRequest()
    this.groupTemplate =
      '<h4 class="text-uppercase text-normal text-semi text-tiny pdgt-- pdgh- sm-pdgt- sm-pdgh">{{title}}</h4>'

    const linkClasses =
      'header-search__link block link pdgh- pdgv-- sm-pdgh sm-pdgv-'
    this.itemTemplates = {
      default: `
      <a href="{{url}}" class="${linkClasses}">
        <div class="text-default text-bold text-h4">{{title}}</div>
      </a>`,
      facility: `
      <a href="{{url}}" class="${linkClasses}">
        <div class="text-default text-bold text-h4">{{title}}</div>
        <div class="text-muted text-tiny">{{address_line1}}, {{postal_code}} {{locality}}</div>
      </a>`,
      occasion: `
      <a href="{{url}}" class="${linkClasses}">
        <div class="text-bold text-h4">{{title}}</div>
        <div class="text-muted text-tiny">{{occasion_date}}</div>
      </a>`,
      event: `
      <a href="{{url}}" class="${linkClasses}" target="_blank">
        <div class="text-bold text-h4">{{title}}</div>
        <div class="text-muted text-tiny">{{from_date}} {{to_date}}</div>
        <div class="text-muted text-tiny">{{sport_name}} - {{location}}</div>
      </a>`
    }

    this.groupTitles = {
      sport: 'Sportarten',
      event: 'Highlights',
      occasion: 'Events',
      facility: 'Sportanlagen',
      page: 'Weitere Ergebnisse'
    }

    this.groupOrder = ['sport', 'event', 'occasion', 'facility', 'page']

    this.groupLengths = {
      sport: 11,
      page: 3,
      occasion: 5,
      facility: 5,
      event: 4
    }

    this.toggled = false
    this.navIndex = 0
    this.results = []
    this.attach()
  }

  attach() {
    this.element.addEventListener('submit', this.onSubmit.bind(this))
    this.searchElement.addEventListener('focus', this.onFocus.bind(this))
    this.searchElement.addEventListener('keyup', this.onKeyUp.bind(this))
    this.searchElement.addEventListener('input', this.onInput.bind(this))
    window.addEventListener('keydown', this.onKeyNavigation.bind(this))

    let overlayEl = document.createElement('div')
    overlayEl.classList.add('header-search__overlay')
    overlayEl.addEventListener('click', () => {
      this.onBlur()
    })
    this.overlayEl = this.element.appendChild(overlayEl)
  }

  onKeyNavigation(event) {
    if (this.toggled && this.results.length > 0 && this.isArrowEvent(event)) {
      event.stopPropagation()
      event.preventDefault()
      this.navigateByKey(event)
    }
  }

  navigateByKey(event) {
    if (event.code == 'ArrowDown') {
      this.navIndex++
    } else {
      this.navIndex--
    }
    if (this.navIndex > this.results.length - 1) {
      this.navIndex = 0
    } else if (this.navIndex < 0) {
      this.searchElement.focus()
      this.navIndex = this.results.length - 1
      return
    }

    this.results[this.navIndex].focus()
  }

  onKeyUp(event) {
    if (!this.isArrowEvent(event)) {
      this.query = this.searchElement.value
      this.loadResults()
    }
  }

  onInput() {
    //this.query = this.searchElement.value;
    //this.loadResults();
  }

  onBlur() {
    window.clearTimeout(this.timeout)
    this.hideSuggestionsDropdown()
    document.body.classList.remove('body--header-search-active')
    this.element.classList.remove('toggled')
    this.timeout = window.setTimeout(() => {
      this.toggled = false
      document.body.classList.remove('body--header-search-prepare')
    }, DROPDOWN_TRANSITION_DURATION)
  }

  onFocus() {
    document.body.classList.remove('menu-open')
    window.clearTimeout(this.timeout)
    this.showSuggestionsDropdown()

    if (this.query.length < 2) {
      this.hideNoResults()
    } else {
      if (this.results.length > 0) {
        this.hideNoResults()
      } else {
        this.showNoResults()
      }
    }

    this.toggled = true
    document.body.classList.add('body--header-search-prepare')
    this.timeout = window.setTimeout(() => {
      this.element.classList.add('toggled')
      document.body.classList.add('body--header-search-active')
    }, 50)
  }

  hideSuggestionsDropdown() {
    this.suggestionsEl.classList.remove('visible')
  }

  showSuggestionsDropdown() {
    this.suggestionsEl.classList.add('visible')
  }

  showNoResults() {
    this.noResults.style.display = 'block'
    this.showSuggestionsDropdown()
  }

  hideNoResults() {
    this.noResults.style.display = 'none'
  }

  isArrowEvent(event) {
    return event.code == 'ArrowUp' || event.code == 'ArrowDown'
  }

  onSubmit(event) {
    event.preventDefault()
    if (this.results[0]) {
      this.results[0].focus()
    } else {
      //to be defined
    }
  }

  loadResults() {
    if (this.query.length < 2) {
      this.resetResults()
      return
    }

    this.request.abort()
    this.request.open(
      'GET',
      `${this.host}/asvz_api/suggestions/${encodeURIComponent(
        this.query
      )}?_format=json`
    )
    this.request.onload = (() => {
      if (this.request.status >= 200 && this.request.status < 400) {
        this.handleResponse(JSON.parse(this.request.responseText))
      } else {
        this.handleError()
      }
    }).bind(this)
    this.request.onerror = this.handleError.bind(this)
    this.request.send()
  }

  handleResponse(data) {
    this.resetResults()

    if (data.count.groups == 0) {
      this.showNoResults()
      return
    }

    const localOffset = new Date().getTimezoneOffset()
    this.timezoneOffset = (localOffset + data.state.utc_offset) * 60

    Object.keys(data.groups)
      .sort((groupA, groupB) => {
        return this.groupOrder.indexOf(groupA) - this.groupOrder.indexOf(groupB)
      })
      .forEach((key) => {
        let groupData = data.groups[key]
        groupData.key = key
        groupData.title = this.groupTitles[key]

        let group = this.getGroupElement(groupData)
        let items = this.getItemsElement(groupData, key)
        group.appendChild(items)

        this.container.appendChild(group)

        this.showSuggestionsDropdown()
        this.results = this.container.querySelectorAll('a.link')

        const links = this.container.querySelectorAll('a')

        for (let i = 0; i < links.length; i++) {
          const a = links[i]
          a.addEventListener('click', this.onLinkClick.bind(this, a))
        }
      })
  }

  resetResults() {
    this.hideNoResults()
    this.navIndex = -1
    this.results = []
    this.container.innerHTML = ''
  }

  parseTemplate(templateStr, data) {
    Object.keys(data).forEach((key) => {
      let value = data[key]

      switch (key) {
        case 'occasion_date': {
          const date = buildDateObject(new Date(value), this.timezoneOffset)
          value = date.fullDate
          break
        }
        case 'from_date': {
          const dateFrom = buildDateObject(new Date(value), this.timezoneOffset)
          value = dateFrom.fullDate
          if (dateFrom.fullTime !== '00:00') {
            value += ' ' + dateFrom.fullTime
          }
          break
        }
        case 'to_date': {
          let startDate = buildDateObject(data.from_date, this.timezoneOffset)
          let dateTo = buildDateObject(new Date(value), this.timezoneOffset)
          if (this.isSameDay(startDate.dateObject, dateTo.dateObject)) {
            if (dateTo.fullTime !== '00:00') {
              value = ' - ' + dateTo.fullTime
            }
          } else {
            value = ' - ' + dateTo.fullDate
            if (dateTo.fullTime !== '00:00') {
              value += ' ' + dateTo.fullTime
            }
          }

          break
        }
      }

      templateStr = templateStr
        .replace(`{{${key}}}`, value)
        .replace(`{{${key}}}`, value)
    })

    for (let unused of [
      'occasion_date',
      'address_line1',
      'postal_code',
      'locality',
      'sport_name',
      'to_date',
      'from_date',
      'location'
    ]) {
      templateStr = templateStr.replace(`{{${unused}}}`, '')
    }

    return templateStr
  }

  getGroupElement(groupData) {
    let group = document.createElement('li')
    group.classList.add('teaser-group')
    group.setAttribute('data-type', groupData.key)
    group.innerHTML = this.parseTemplate(this.groupTemplate, groupData)
    return group
  }

  getItemsElement(groupData, key) {
    let items = document.createElement('ul')
    items.classList.add('list-stacked')
    items.classList.add('list-stacked--tight')
    let template = this.itemTemplates.default
    let parsedItem = ''
    if (this.itemTemplates[key]) {
      template = this.itemTemplates[key]
    }

    for (
      let i = 0;
      i < Math.min(groupData.items.length, this.groupLengths[key]);
      i++
    ) {
      parsedItem = this.parseTemplate(template, groupData.items[i])
      if (key === 'sport' || key === 'facility') {
        parsedItem = this.getButtonizedTemplate(
          key,
          groupData.items[i],
          parsedItem
        )
      }
      items.innerHTML +=
        '<li class="header-search__item">' + parsedItem + '</li>'
    }
    return items
  }

  getButtonizedTemplate(type, itemData, parsedItem) {
    return `
      <div class="header-search__suggestions__group--parent">
        ${parsedItem}
        <div class="header-search__suggestions__group pdgb pdgl- sm-pdg0 sm-pdgr">
          <a href="${itemData.event_search_url}" data-title="${itemData.title}" class="btn btn--border btn--small suggestions-btn--events" tabindex="-1">Sportfahrplan</a>
          <a href="${itemData.url}" data-title="${itemData.title}" class="btn btn--border btn--small mrgl-- suggestions-btn--details" tabindex="-1">Mehr erfahren</a>
        </div>
      </div>
    `
  }

  onLinkClick(link, event) {
    if (this.dataLayerCatched) return
    let destination = 'detail',
      title = '',
      category = ''

    if (link.classList.contains('header-search__link')) {
      title = link.querySelector('.text-h4').innerHTML
      destination = 'detail'
    } else {
      if (link.classList.contains('suggestions-btn--events')) {
        destination = 'events'
      }
      title = link.getAttribute('data-title')
    }

    try {
      for (let i = 0; i < event.path.length; i++) {
        if (event.path[i].classList.contains('teaser-group')) {
          category = event.path[i].getAttribute('data-type')
          break
        }
      }
    } catch (e) {
      // Don't do anything.
    }

    window.dataLayer.push({
      event: 'search',
      search_query: this.query,
      search_title: title,
      search_destination: destination,
      search_category: category
    })

    this.dataLayerCatched = true
  }

  isSameDay(dateFrom, dateTo) {
    return (
      dateFrom.getDate() === dateTo.getDate() &&
      dateFrom.getMonth() === dateTo.getMonth() &&
      dateFrom.getFullYear() === dateTo.getFullYear()
    )
  }

  formatTime(date) {
    return `${withLeading(date.getHours())}:${withLeading(date.getMinutes())}`
  }

  formatDate(date) {
    return `${withLeading(date.getDate())}.${withLeading(
      date.getMonth() + 1
    )}.${date.getFullYear()}`
  }

  handleError() {
    // eslint-disable-next-line
    console.log('QuickSearch Error', this)
  }
}
